const reducer = (state = '', action) =>{
    switch(action.type){
        case "setContractSearch": 
            return action.payload;
        default: 
            return state;
    }
}

export default reducer;  